import React from 'react';


class Footer extends React.Component {

    // componentWillMount() {
    //     (function (d, s, id) {
    //         var js, fjs = d.getElementsByTagName(s)[0];
    //         if (d.getElementById(id)) return;
    //         js = d.createElement(s); js.id = id;
    //         js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js#xfbml=1&version=v2.12&autoLogAppEvents=1';
    //         fjs.parentNode.insertBefore(js, fjs);
    //     }(document, 'script', 'facebook-jssdk'));
    // }
    render() {

        return (
            <div style={{ backgroundColor: '#1a1a1a' }}>
                <div id="fb-root"></div>
                <footer className="copy-right-bg">
                    <div className="container">
                        <div className="row">
                            {/* <div className="col-md-12 text-center">
                                <div className="social-footer">
                                    <ul>
                                        <li><a href={null} dangerouslySetInnerHTML={{ __html: '<i class="fa fa-facebook" aria-hidden="true"></i>' }}></a></li>
                                        <li><a href={null} dangerouslySetInnerHTML={{ __html: '<i class="fa fa-google-plus" aria-hidden="true"></i>' }}></a></li>
                                        <li><a href={null} dangerouslySetInnerHTML={{ __html: '<i class="fa fa-twitter" aria-hidden="true"></i>' }}></a></li>
                                        <li><a href={null} dangerouslySetInnerHTML={{ __html: '<i class="fa fa-instagram" aria-hidden="true"></i>' }}></a></li>
                                        <li><a href={null} dangerouslySetInnerHTML={{ __html: '<i class="fa fa-rss" aria-hidden="true"></i>' }}></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            <div className="col-md-12 text-center">
                                <p className="copyright">
                                    © 2024 crwd.tech, LLC. All Rights Reserved.
                                </p>
                                {/* link to privacy policy */}
                                <p>
                                    <a href="/privacy-policy" target='_blank' rel="noreferrer"
                                        style={{
                                            color: '#586082',
                                            textDecoration: 'none',
                                        }}>Privacy Policy</a>
                                </p>
                                <p>
                                    <a href="/support" rel="noreferrer"
                                        style={{
                                            color: '#586082',
                                            textDecoration: 'none',
                                        }}>Support</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>
                {/*Your customer chat code*/}
                {/* <div className="fb-customerchat"
                    page_id="2123438804574660"
                    theme_color="#5f57ea"
                    logged_in_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?"
                    logged_out_greeting="Hi! Welcome to PixelStrap Themes  How can we help you?">
                </div> */}
            </div>
        );
    }
}


export default Footer;